import React, { useState } from "react";
import { Layers } from "lucide-react";
import { ToggleRow, Slider } from "@/components/finishing/Controls";

export const SceneMatchCard = ({ value, scenes, onSave }) => {
  const sm = value || { enabled: false, strength: 0.7 };
  const [strength, setStrength] = useState(null);
  const rows = scenes?.scenes || [];
  return (
    <div className="studio-card p-5 space-y-4" data-testid="scene-match-card">
      <div className="flex items-center gap-2"><Layers size={16} className="text-[#00F0FF]" /><span className="font-head font-bold">Scene Color Matching</span></div>
      <ToggleRow label="Match clips within each scene" desc="Anchors each scene to its best-exposed clip, on top of camera matching"
        on={sm.enabled} onClick={() => onSave({ ...sm, enabled: !sm.enabled })} testid="scene-match-toggle" />
      <Slider label="Match strength" value={strength ?? sm.strength} min={0} max={1} testid="scene-match-strength"
        fmt={(v) => `${Math.round(v * 100)}%`} onChange={setStrength}
        onCommit={(v) => { setStrength(null); onSave({ ...sm, strength: v }); }} />
      {rows.length === 0 ? <p className="text-xs text-[#64748B]">Generate an edit plan and run color analysis to see per-scene results.</p> : (
        <div className="max-h-56 overflow-y-auto space-y-1.5" data-testid="scene-match-rows">
          {rows.map((r) => (
            <div key={r.scene} className="flex items-center gap-3 text-xs">
              <span className="flex-1 truncate">{r.scene}</span>
              <span className="text-[#64748B] truncate max-w-[140px]" title="anchor clip">⚓ {r.anchor}</span>
              <span className="font-mono">{r.spread_before} → <span className="text-[#34d399]">{r.spread_after}</span></span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
